/**
 * onboardingFunnel.js
 * ===================
 * FONTE UNICA do predicado de funil de onboarding (C2, jul/2026).
 *
 * Consumido por DOIS gates que devem concordar caractere-a-caractere:
 *   - CentralGate (App.js)          — funil na rota /central
 *   - RouteGuard (components/guards) — funil nas rotas role-gated (URL direta)
 * Mesma condicao + mesmo destino = idempotentes entre si. Dois guards de
 * onboarding que discordam e como se cria vazamento; extrair pra helper e o
 * mesmo principio de fonte-unica que consertou os esportes (e8ceefb/9700802).
 *
 * TOKEN-TRUTH: le rbacData.roles (verdade do token), NUNCA activeRole
 * (UX-only — RULE do proprio RouteGuard). Cronologia git (7db79ee) provou
 * que o eixo deliberado do CentralGate era userType-vs-RBAC, nunca
 * activeRole-vs-token. Para a populacao pending (single-role por
 * construcao — /onboarding/start concede exatamente uma role)
 * token-truth e comprovadamente equivalente a activeRole.
 *
 * PENDING-ONLY: 'none' e LIVRE (D1 jul/2026 — o fallback GESTOR+none
 * recapturava gestores reais como demo.gestor; matriz provou 141/141
 * users com status). CHECK constraint: none/pending/completed.
 * 'completed' NUNCA funila (aresta critica — regressao simetrica do
 * approved->200 do Launch Gate). Estado desconhecido (null/undefined,
 * ex: erro do /me) NAO funila — ausencia de informacao nao e 'pending'.
 */

const SETUP_ROLES = ['GESTOR', 'TREINADOR'];

/** Destino unico do funil — o wizard vive atras de StandaloneAuthRoute
 *  (ADR-3), fora do RouteGuard, entao o funil nunca se auto-tranca. */
export const WIZARD_PATH = '/manager/setup';

/**
 * @param {object|null} rbacData - payload do /me como exposto pelo RBACContext
 * @returns {boolean} true sse onboarding_status === 'pending' E as roles do
 *                    TOKEN contem uma setup-role (GESTOR/TREINADOR).
 */
export function shouldFunnelToWizard(rbacData) {
  if (!rbacData) return false;
  if (rbacData.user?.onboarding_status !== 'pending') return false;
  const tokenRoles = (rbacData.roles || [])
    .map((r) => r?.role_key)
    .filter(Boolean);
  return tokenRoles.some((r) => SETUP_ROLES.includes(r));
}
